module.exports = __webpack_public_path__ + "static/media/C20-0321_Bison_Desktop_2396x1473.dca22d06.jpg";